import {ReportLayout} from 'common/report/contexts/report-layout/types';

export const REPORT_LAYOUT_TO_KEYBOARD_CODE: Map<ReportLayout, string> = new Map([
  [ReportLayout.SplitChartTable, `Digit2`],
  [ReportLayout.SplitTableOnly, `Digit3`],
  [ReportLayout.SplitChartOnly, `Digit4`],
]);

export const KEYBOARD_CODE_TO_KEY: Map<string, string> = new Map([
  [`Digit2`, `2`],
  [`Digit3`, `3`],
  [`Digit4`, `4`],
]);
